"use client"

import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from "react"
import { FormInput } from "./UmbracoApartments/FiltersModal"

type FilterContextType = {
  state: FormInput
  setState: Dispatch<SetStateAction<FormInput>>
  defaultState: FormInput
  filtersCount: number
  setFiltersCount: Dispatch<SetStateAction<number>>
  handleReset: () => void
}

const FilterContext = createContext<FilterContextType | undefined>(undefined)

export function useFilters() {
  const context = useContext(FilterContext)
  if (!context) {
    throw new Error("useFilters must be used within FilterProvider")
  }
  return context
}

type Props = {
  children: ReactNode
  defaultState: FormInput
}

export function FilterProvider({ children, defaultState }: Props) {
  const [state, setState] = useState(defaultState)
  const [filtersCount, setFiltersCount] = useState(0)

  const handleReset = () => {
    setState(defaultState)
    setFiltersCount(0)
  }

  return (
    <FilterContext.Provider
      value={{
        state,
        setState,
        defaultState,
        filtersCount,
        setFiltersCount,
        handleReset,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}
